import axios from 'axios';
import store from '../store/index';
import {authService} from "../services/authenticationServiceInstance";



axios.interceptors.response.use(
    function (response) { return response; },
    function (error) {
        if (error && error.response.status == 401) {
            store.dispatch('setUnAuthorizedUser');
        }
        if(error && error.response.status == 403){
            authService.login();
        }
        if(error && error.response.status == 400){
            return error.response
        }
    });